import React from 'react'
import { Typography, Grid, Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';

export const Construction = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
      navigate(-1); // Navigates to the previous page
    };
  
  
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh' }}
      spacing={2}
    >
      <Grid item>
        <Typography variant="h3" component="h1">
          Under Maintenance
        </Typography>
      </Grid>
      <Grid item>
        <Button variant="contained" onClick={handleGoBack} sx={{ backgroundColor: "#34A56F", "&:hover": { backgroundColor: "#2D905E" } }}>
          Go Back
        </Button>
      </Grid>
    </Grid>
  )
}
